import { render, staticRenderFns } from "./OtherParam.vue?vue&type=template&id=50f05960"
import script from "./OtherParam.vue?vue&type=script&lang=js"
export * from "./OtherParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports